<template>
    <div class="checkin-status-container">
        <div class="checkin-status-icon">
            <img :src="checkinImg" alt="签到" class="checkin-img" />
            <!-- <img src="../../assets/img/img/checkin_tip.png" alt="签到" class="checkin-img"> -->
        </div>
        <!-- <div class="checkin-status-text">签到失败，请重试</div> -->
        <div class="checkin-success-text">{{ state.msg || "签到成功" }}</div>
        <div class="checkin-status-button" @click="navigateToPage()">返回</div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
import checkinSuccess from "@/assets/img/checkin_tip.png";
const router = useRouter();
const route = useRoute();
const checkinImg = checkinSuccess;
const navigateToPage = () => {
    router.back();
};
const state = reactive({
    msg: "",
});
onMounted(() => {
    const msg = route.query.msg || "";
    state.msg = msg;
    // if (msg) {
    //     showFailToast(msg);
    // }
});
</script>
<style lang="less" scoped>
.checkin-status-container {
    background-color: #fff;
    padding: 20px;
    height: 100vh;
    .checkin-status-icon {
        margin: 50px auto 10px;
        width: 135px;
        height: 135px;
        .checkin-img {
            width: 100%;
            height: 100%;
        }
    }
    .checkin-status-text {
        font-size: 27px;
        font-weight: 500;
        color: #ff0105;
        margin-bottom: 20px;
        text-align: center;
        font-family: "PingFang SC-Semibold";
    }
    .checkin-success-text {
        font-size: 27px;
        font-weight: 500;
        color: #3bcb84;
        margin-bottom: 20px;
        text-align: center;
        font-family: "PingFang SC-Semibold";
    }
    .checkin-status-button {
        width: 100%;
        height: 50px;
        background-color: #dcbb89;
        color: #fff;
        font-size: 19px;
        font-weight: 500;
        border-radius: 11px;
        text-align: center;
        line-height: 50px;
    }
}
</style>
